import { takeEvery, put, call } from "redux-saga/effects"
import { CANCEL_SCHEDULE, CANCEL_SUBSCRIPTION, CHECK_PLAN_LIMIT, DOWNGRADE_PLAN, GET_ESTIMATION_DETAILS, GET_PLANS_LIST, UPGRADE_PLAN } from "./actionTypes"
import { LystfaceCancelSchedule, LystfaceCancelSubscription, LystfaceCheckEstimationDetails, LystfaceCheckPlanLimit, LystfaceDownGradePlan, LystfaceGetPlanList, LystfaceUpgradePlan } from "../../../helpers/lystface_helper"
import { setCancelSchedule, setCancelSubscription, setDowngradePlan, setEstimationDetails, setPlanLimit, setPlansList, setUpgradePlan } from "./actions"

function* watchForGetPlansList() {
  try {
    const Result = yield call(LystfaceGetPlanList)
    if (Result.responseCode) {
      yield put(setPlansList(Result))
    } else {
      yield put(setPlansList(Result))

    }
  } catch (error) {
    console.log(error)
    yield put(setPlansList({ responseCode: 0, responseMessage: "Error in fetching plans list,Please try again..", responseStatus: 'Error' }))

  }
}
function* watchForCancelSubsciption({ payload }) {
  try {
    const Result = yield call(LystfaceCancelSubscription)
    if (Result.responseCode) {
      yield put(setCancelSubscription(Result))
    } else {
      yield put(setCancelSubscription(Result))

    }
  } catch (error) {
    console.log(error)
    yield put(setCancelSubscription({ responseCode: 0, responseMessage: "Error in canceling plans ,Please try again..", responseStatus: 'Error' }))

  }
}
function* watchForCheckPlanLimit({ payload }) {
  try {
    const { plan: planId } = payload
    const Result = yield call(LystfaceCheckPlanLimit, payload)
    if (Result.responseCode) {
      yield put(setPlanLimit({ ...Result, planId }))
    } else {
      yield put(setPlanLimit({ ...Result, planId }))

    }
  } catch (error) {
    console.log(error)
    yield put(setPlanLimit({ responseCode: 0, responseMessage: "Error in fetchig plan limit ,Please try again..", responseStatus: 'Error' }))

  }
}
function* watchForGetEstimationDetails({ payload }) {
  try {
    const { process, plan, coupon, from } = payload
    const requestpayload = { process, plan, coupon }
    const Result = yield call(LystfaceCheckEstimationDetails, requestpayload)
    if (Result.responseCode) {
      yield put(setEstimationDetails({ ...Result }))
    } else {
      yield put(setEstimationDetails({ ...Result }))

    }
  } catch (error) {
    console.log(error)
    yield put(setEstimationDetails({ responseCode: 0, responseMessage: "Error in fetchig estimation details ,Please try again..", responseStatus: 'Error' }))

  }
}
function* watchForUpgradePlan({ payload }) {
  try {
    const { plan_id } = payload
    const Result = yield call(LystfaceUpgradePlan, payload)
    if (Result.responseCode) {
      yield put(setUpgradePlan({ ...Result, plan_id: parseInt(plan_id) }))
    } else {
      yield put(setUpgradePlan(Result))

    }
  } catch (error) {
    console.log(error)
    yield put(setUpgradePlan({ responseCode: 0, responseMessage: "Error in upgrading plan ,Please try again..", responseStatus: 'Error' }))

  }
}
function* watchForDowngradePlan({ payload }) {
  try {
    const Result = yield call(LystfaceDownGradePlan, payload)
    if (Result.responseCode) {
      yield put(setDowngradePlan(Result))
    } else {
      yield put(setDowngradePlan(Result))

    }
  } catch (error) {
    console.log(error)
    yield put(setDowngradePlan({ responseCode: 0, responseMessage: "Error in downgrading plan  ,Please try again..", responseStatus: 'Error' }))

  }
}
function* watchForCancelSchedule({ payload }) {
  try {
    const Result = yield call(LystfaceCancelSchedule, payload)
    if (Result.responseCode) {
      yield put(setCancelSchedule({ ...Result, ...payload }))
    } else {
      yield put(setCancelSchedule({ ...Result, ...payload }))

    }
  } catch (error) {
    console.log(error)
    yield put(setCancelSchedule({ responseCode: 0, responseMessage: "Error in cancelling schedule  ,Please try again..", responseStatus: 'Error' }))

  }
}


function* PricingSaga() {
  yield takeEvery(GET_PLANS_LIST, watchForGetPlansList)
  yield takeEvery(CANCEL_SUBSCRIPTION, watchForCancelSubsciption)
  yield takeEvery(CHECK_PLAN_LIMIT, watchForCheckPlanLimit)
  yield takeEvery(GET_ESTIMATION_DETAILS, watchForGetEstimationDetails)
  yield takeEvery(UPGRADE_PLAN, watchForUpgradePlan)
  yield takeEvery(DOWNGRADE_PLAN, watchForDowngradePlan)
  yield takeEvery(CANCEL_SCHEDULE, watchForCancelSchedule)

}
export default PricingSaga
